import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/public/homePage/icons/bullet.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/sports/ad.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/sports/event-research.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/sports/market-analysis.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/sports/patient-insights.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/sports/sponsorship.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/sports/sports.png");
;
import(/* webpackMode: "eager" */ "/app/public/slm/icon/home.svg");
